<div class="d-flex flex-row flex-auto">
  <div class="input-field-color">
    <label *ngIf="priority">{{'platform_settings.chart_color_priority' | translate:{priority: priority} }}</label>
    <label *ngIf="label">{{label}}</label>
    <input
      class="form-control {{inputStyleModifier}}"
      [name]="name || label"
      [attr.maxlength]="getMaxLength()"
      [attr.disabled]="disabled ? 'disabled' : null"
      [attr.id]="buildChildId()"
      [attr.placeholder]="placeholder || null"
      [attr.aria-required]="required || null"
      [ngModel]="model"
      (ngModelChange)="onModelChange($event)"
      #entryComponent
    />
  </div>
  <div class="d-flex justify-content-end flex-column preview-color-selection">
    <span class="preview-color"
          [style.color]="color"
          [style.backgroundColor]="color"
          (click)="onClickColorPicker()"
          (clickOutside)="onClickOutside($event)"></span>
    <div id="colorPickerContainer{{priority || id}}" class="color-picker-container" [ngClass]="{'open': showColorPicker}" *ngIf="showColorPicker">
      <achoo-color-picker #ColorPicker [color]="color" [defaultColor]="defaultColor" (changeColorEvent)="onChangeColor($event)"></achoo-color-picker>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-color-field/achoo-color-field.component.html